import { gql } from "@apollo/client";

export const SystemClientContract = gql`
    query SystemClientContract($id: ID!) {
        system(id: $id) {
            id
            client {
                id
                contract {
                    id
                    contractDurationFrom
                    contractDurationTo
                }
            }
        }
    }
`;
